import { getTsApiV1Client } from '@montugroup/circuit-shared/api/api-v1.client';
import getAuthBearerToken from '@montugroup/circuit-shared/utils/getAuthBearerToken';

const client = getTsApiV1Client();
const { useQuery, keys } = client.pharmacy.getPharmacistDetails;

export function useGetPharmacistDetails() {
  return useQuery({
    queryKey: keys,
    queryData: {
      query: {},
      headers: { authorization: getAuthBearerToken() },
    },
    select: (response) => response.body,
  });
}
